import { P, InfoBox } from '@sellpy/design-system-react-web'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useQuery } from '@apollo/client'
import { RadioGroup } from '../../uiComponents'
import { getActiveAutomaticPayoutConfig } from './optInAutomaticPayouts.gql'

const OptInAutomaticTransfersContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.color.grey.shade8};
  border-radius: 8px;
  gap: 8px;
`

const OptInAutomaticPayouts = ({ labelKey }) => {
  const {
    register,
    formState: { errors }
  } = useFormContext()
  const { t } = useTranslation('automaticPayout')
  const { data, loading } = useQuery(getActiveAutomaticPayoutConfig)

  const hasAutomaticPayoutConfig = data?.automaticPayoutConfigs?.edges?.[0]?.node?.objectId != null

  if (loading) return null

  if (hasAutomaticPayoutConfig) return null

  const options = [
    { value: true, label: t('optIn.yes') },
    { value: false, label: t('optIn.no') }
  ]

  return (
    <OptInAutomaticTransfersContainer>
      <InfoBox title={t('optIn.infobox')} variant={'subtle'} />
      <P design='body3'>{t('optIn.topInformation')}</P>
      <P design='body2' noMargin>
        {t(labelKey)}
      </P>
      <RadioGroup
        name={'updateAutomaticPayouts'}
        register={register}
        registerOptions={{
          required: t('formValidation.reasonError')
        }}
        options={options}
        errors={errors}
      />

      <P design='body3'>{t('optIn.bottomInformation')}</P>
    </OptInAutomaticTransfersContainer>
  )
}

export default OptInAutomaticPayouts
